import { DefaultTheme } from 'styled-components';

const lightTheme: DefaultTheme = {
  font: {
    family: 'GT Haptik',
    weight: {
      regular: 400,
      medium: 500,
      bold: 700,
    },
    size: {
      huge: '24px',
      big: '16px',
      regular: '14px',
    },
  },
  border: {
    radius: '8px',
    style: 'solid',
    width: '1px',
  },
  colors: {
    primary: '#FF3B81',
    soft: '#FF9DC0',
    confirmed: '#AAFF21',
    light: '#B3BBC4',
    pending: '#F7B501',
    header: '#000000',
    failed: '#E02020',
    text: '#6D7278',
    clickable: '#A1AECA',
  },
};

export default lightTheme;
